import { mailFaviconProvider, mailOverlayIconProvider } from './mailFaviconProviders';

// Initialize orchestrators
import '../orchestrators/onFolderSelectedOrchestrator';
import '../orchestrators/onNewMessageOrchestrator';
import '../orchestrators/onPageVisibilityChanged';

export default function getMailFavicon(): {
    icon: string;
    overlay: string | undefined;
} {
    return { icon: mailFaviconProvider(), overlay: mailOverlayIconProvider() };
}
